"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RIGHT_BUTTON = exports.LEFT_BUTTON = void 0;
const LEFT_BUTTON = exports.LEFT_BUTTON = 'left-button';
const RIGHT_BUTTON = exports.RIGHT_BUTTON = 'right-button';
